const BASE_SERVER_URL = 'http://localhost:5000/api/v1';
export {BASE_SERVER_URL};